import RetailerApi from "@/services/api/retailerApi";
import FavoriteApi from "@/services/api/favoritesApi.js";
import { mapGetters } from "vuex";
import RetailerProfileHeader from "@/views/brandBio/retailerProfileHeader/retailerProfileHeader.vue";
import BrandStockist from "../brandStockist/brandStockist.vue";
import BrandPosts from "../brandPosts/brandPosts.vue";
import algoliasearch from "algoliasearch/lite";
import InlineSvg from "vue-inline-svg";

const RetailerApiService = new RetailerApi(),
  FavoriteApiService = new FavoriteApi();

export default {
  components: {
    BrandPosts,
    RetailerProfileHeader,
    BrandStockist,
    InlineSvg,
  },

  data() {
    return {
      isPublic: false,
      searchIndex: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      profileData: null,
      isSearchActive: false,
      keyword: this.$route.query.keyword,
      isFilterVisible: false,
      favoriteList: [],
      filterOrSortUsed: false,
      filtersOrSortsUsed: new Set(),
      priceRange: this.$utils.constants.ALGOLIA_DEFAULT_PRODUCT_SEARCH_NUMERIC_FILTER,
      canCheckFave: this.$session.getUserInfo() === null ? false : this.$session.getUserInfo().role === "RETAILER",
      items: [],
    };
  },

  methods: {
    getProfile,
  },

  beforeMount() {
    if (!this.$route.params.id && this.user) {
      this.$router.replace(`/retailer/${this.user.retailer_id}`);
    }
    if (this.canCheckFave) {
      FavoriteApiService.getFavoriteProducts()
        .then((result) => {
          this.favoriteList = result.data.product_ids;
          if (this.favoriteList === undefined) {
            this.favoriteList = [];
          }
          this.getProfile();
        })
        .catch((error) => {
          if (error.response) {
            this.$swal("Attention", error.response.data.error_message);
          } else {
            this.$bugsnagClient.notify(new Error(error));
          }
        });
    } else {
      this.getProfile();
    }
  },
  computed: {
    isABrandUserOnTheirOwnBrandPage: function () {
      return this.user && this.user.role === "BRAND" && this.user.brand_vanity_url_name === this.$route.params.brandUrl;
    },

    ...mapGetters({
      user: "userState",
    }),
    carousel() {
      return this.$refs.carousel.$swiper;
    },
    carouselOptions() {
      /* to outsmart the linter 1 + 1 = 2 */
      const canCenter = this.profileData.store_gallery.length > 1 + 1;
      return {
        slidesPerView: "auto",
        spaceBetween: 30,
        centeredSlides: true,
        ...(canCenter && {
          initialSlide: 1,
        }),
      };
    },
  },
};

function getProfile() {
  const retailerId = this.$route.params.id;
  RetailerApiService.getRetailerProfileById(retailerId)
    .then(({ data }) => {
      this.isPublic = data.is_public;
      this.profileData = {
        ...data,
        ...{
          pillList: this.isPublic ? data.store_types.concat(data.values) : data.store_types,
        },
      };
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    });

  RetailerApiService.getRetailerOrderList(retailerId).then(({ data }) => {
    this.items = data;
  });
}
